import {
  Alert,
  AlertDescription,
  AlertTitle,
  Checkbox,
  type CheckboxProps,
  Field,
  FieldContent,
  FieldLabel,
  type FieldRootProps,
} from '@glade-ai/ui';
import { type FC } from 'react';

import Link from '@/components/CustomLink';
import DeviceMobile from '@/components/Icons/DeviceMobile';
import { IDENTIFIERS, getUrl } from '@/helpers/urlsHelper';

type SmsOptInProps = {
  label: string;
  creatorSlug: string;
  isCreatorView?: boolean;
} & CheckboxProps &
  Pick<FieldRootProps, 'id'>;

export const SmsOptIn: FC<SmsOptInProps> = ({
  isCreatorView,
  creatorSlug,
  label,
  id,
  ...checkboxProps
}: SmsOptInProps) => (
  <Alert className='!grid-cols-[min-content_1fr] gap-2'>
    <DeviceMobile className='justify-self-center' />
    <AlertTitle>Enable SMS notifications</AlertTitle>
    <AlertDescription className='col-span-2 col-start-1 grid-cols-subgrid'>
      <Field id={id}>
        <FieldContent orientation='horizontal' className='grid col-span-2 grid-cols-subgrid'>
          <Checkbox {...checkboxProps} />
          <FieldLabel className='font-normal leading-normal'>{label}</FieldLabel>
        </FieldContent>
      </Field>

      {!isCreatorView && (
        <p className='col-start-2 text-sm'>
          <Link to={getUrl(IDENTIFIERS.CREATOR_MESSAGING_TERMS, { creatorSlug })} newTab>
            Terms of Service
          </Link>
          {' | '}
          <a href='https://www.glade.ai/privacy-policy' target='_blank' rel='noopener noreferrer'>
            Privacy Policy
          </a>
        </p>
      )}
    </AlertDescription>
  </Alert>
);
